import styles from '../WalletContent/Content/styles.module.scss';
import SkeletonButtons from '../WalletContent/Content/Buttons/Skeleton';
import SkeletonFindedAccounts from '../WalletContent/Content/FindedAccounts/Skeleton';
import SkeletonInfoBalance from '../WalletContent/Content/InfoBalance/Skeleton';
import skeleton from './styles.module.scss';

export default function SkeletonNoEmptyWalletModalContent() {
  return (
    <div className={styles.container}>
      <div className={styles.container__wrapper}>
        <SkeletonInfoBalance />
        <div className={styles['container__wrapper__your-coins']}>
          <div className={styles['container__wrapper__your-coins__title']}>
            <div className={skeleton.text} />
            <div className={skeleton.text} />
          </div>
          <SkeletonFindedAccounts />
        </div>
      </div>
      <SkeletonButtons />
    </div>
  );
}
